var _defs, _path, _path2, _path3, _path4, _circle, _circle2, _path5, _path6, _path7, _path8, _path9, _path0, _circle3, _circle4, _line, _path1, _ellipse, _ellipse2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 366.34 366.34",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e18477;}.cls-2{fill:#a76962;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5,.cls-7{fill:none;stroke-miterlimit:10;}.cls-5{stroke:#00214e;}.cls-6{fill:#00214e;}.cls-7{stroke:#ffffff;}.cls-8{fill:#ffffff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 140.91,
    y1: 159.12,
    x2: 288.5,
    y2: 36.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16243f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6878b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 228.69,
    y1: 124.59,
    x2: 298.39,
    y2: 124.59,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboards_Diversity_Avatars_by_Netguru") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.43,285.76a184.56,184.56,0,0,1-226.48-1l48.66-22.81a46.83,46.83,0,0,0,6.65-3.82c.64-.44,1.28-.9,1.89-1.38a46.35,46.35,0,0,0,12.78-15.09,44.69,44.69,0,0,0,4.64-14.48,67.91,67.91,0,0,0,.74-9.91c0-5.72-.31-11.44-.37-17.17q-.06-4.76-.1-9.51l2,1,5.2,2.69,2.41.41,27.88,4.74,31.12,5.3.94,32,.31,10.46.15,5.08v.33l12.1,4.92Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.81,251.37a16,16,0,0,1-10.07-1.56L143.07,201c-.07-2.26-.13.11-.16-2.15q-.06-4.75-.1-9.51l2,1,5.2,2.69,2.41.41,27.88,4.74,31.12,5.3.94,32,.31,10.46.15,5.08v.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M257.43,89.23a90.48,90.48,0,0,1,38.48,42.88,80.12,80.12,0,0,0-19.49,4.06l-.06,0q-2.46.84-4.88,1.85l-1,.43-1.59.7,0,0c-.53.23-1.06.48-1.58.74s-1,.51-1.57.78-1,.53-1.55.81-.91.49-1.36.75c-1.08.6-2.14,1.23-3.18,1.88q-.62.38-1.23.78a78.68,78.68,0,0,0-11.25,8.83c-4.39,4.15-8.49,8.92-13,13.18a46.31,46.31,0,0,1-13.38,9.39c-9.64,4.15-20.79,6.55-30.8,10l-47,16.25c0-.74-5.32-6-12-12.41a91.07,91.07,0,0,1-28.3-64c-1.62-73.26,84.44-94.8,143-79.1A91.21,91.21,0,0,1,271.9,58.77,76,76,0,0,1,286.44,71,63.12,63.12,0,0,1,298.39,89.5l-.79-.14A112.73,112.73,0,0,0,257.43,89.23Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M295.91,132.11a80.12,80.12,0,0,0-19.49,4.06l-.06,0a47.36,47.36,0,0,0-4.88,1.85l-1,.43-1.61.72c-.53.24-1.05.48-1.58.74s-1,.51-1.57.78-1,.53-1.55.81-.91.49-1.36.75c-1.08.6-2.14,1.23-3.18,1.88l-1.23.78a78.68,78.68,0,0,0-11.25,8.83c-4.39,4.15-8.49,8.92-13,13.18-1.46.6-2.91,1.23-4.36,1.86.18-.08-1.15-17-1.11-18.71a110.5,110.5,0,0,1,2.23-19.44c2.54-12.31.92-23.76,3.37-36.38a80.44,80.44,0,0,1,2-8.35c4.18-3.12,10-4.08,15.07-4.81C263.5,79.34,276,81,287.69,84.68a57.24,57.24,0,0,1,5.69,2.14c.88.39,1.74.81,2.59,1.26a12.24,12.24,0,0,0,2.42,1.42,117.17,117.17,0,0,0-41-.27A90.48,90.48,0,0,1,295.91,132.11Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 133,
    cy: 162.58,
    r: 17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 138.39,
    cy: 162.58,
    r: 15.22
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.62,146.54l4.38,57,66.44,38.82a19.77,19.77,0,0,0,24.68-9.86c9.56-19.58,24.9-50.49,22.88-62-3-17-11-23-11-23q1.67-10,3.32-19.94c1.26-7.51,2.86-15.35,1-22.9-2.13-8.65-8.67-12.35-14.05-18.82-14.16,18.24-37.44,28.55-57.77,39C168,130.36,138.62,146.54,138.62,146.54Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M170.67,134.75A80.57,80.57,0,0,1,198.8,134"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M229.72,134.86a55.64,55.64,0,0,1,17.45-1.21"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M206.69,173.34a3.4,3.4,0,0,0,2.11,6.38"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M224.74,163s.29,5.65,1.62,8.3c.57,1.14,1.46,2.1,2,3.24,2.21,4.33-1.36,5.25-4.81,5.25"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M294.43,285.76a184.56,184.56,0,0,1-226.48-1l48.66-22.81a46.83,46.83,0,0,0,6.65-3.82c.64-.44,1.28-.9,1.89-1.38a46.35,46.35,0,0,0,12.78-15.09,44.69,44.69,0,0,0,4.64-14.48,28.66,28.66,0,0,0,2.22,1.94,95.14,95.14,0,0,0,19.82,11.26,99,99,0,0,0,10.46,3.69,93.52,93.52,0,0,0,33,3.49c1.54-.12,3.09-.27,4.63-.38l.15,5.08v.33l12.1,4.92Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 191.59,
    cy: 149.75,
    r: 19
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 244.73,
    cy: 146.75,
    r: 19
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 210.59,
    y1: 149.75,
    x2: 225.73,
    y2: 148.45
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M190.17,191.23a1.87,1.87,0,0,1,2.69-.5c2.07,1.46,5.88,4.56,11.28,5.63,7.36,1.47,13.74-1.48,15.27.42.86,1.07-.19,2.38-2.2,4.05a19.75,19.75,0,0,1-14.86,3.69c-7.08-1.33-12.4-9.53-12.4-12.44A1.79,1.79,0,0,1,190.17,191.23Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 187.13,
    cy: 149.58,
    rx: 3.27,
    ry: 7.94,
    transform: "translate(24.14 325.16) rotate(-85.77)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 238.63,
    cy: 147.94,
    rx: 7.94,
    ry: 3.27,
    transform: "translate(-19.94 38.53) rotate(-8.86)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIcon);
export default __webpack_public_path__ + "static/media/avatar_icon.c306e71f9f94df8b3dce597dce2174ed.svg";
export { ForwardRef as ReactComponent };